export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8857.839da41c.jpg";